//import Libraries
import React from 'react';
import Parser from 'html-react-parser';
//import Components

//import Style classes
import './BlogModal.css';

const blogModal = ({title, text}) => {

    return (
        <div className="BlogModalWrapper">
            <h4>제목: {title}</h4>
            <hr style={{margin: 0}}/>
            <div>
                { Parser(text)}
            </div>
        </div>
    )
}

export default blogModal;



// WEBPACK FOOTER //
// ./src/pages/Community/Blog/BlogModal/BlogModal.js